<script>
    import {createEventDispatcher} from 'svelte';
    import CampoDeTexto from "../../UI/CampoDeTexto.svelte";
    import store from '../../../Stores/trabajador-store';
    import storeGrupos from '../../../Stores/grupos-store';
    import storeSedes from '../../../Stores/sedes-store';
    import CampoDeSeleccion from "../../UI/CampoDeSeleccion.svelte";
    import {nombreCompleto, validaTrabajador} from '../../../Modelos/Trabajador';
    import Boton from "../../UI/Boton.svelte";
    import Caja from "../../UI/Caja.svelte";
    import Subtitulo from "../../UI/Subtitulo.svelte";
    import {creaOpciones} from "../../../Utils/selects";
    import CampoDeImagen from "../../UI/CampoDeImagen.svelte";
    import CampoDeFecha from "../../UI/CampoDeFecha.svelte";
    import CampoDeCheckbox from "../../UI/CampoDeCheckbox.svelte";

    export let titulo;

    const aplanarGrupos = grupos => {
        const reducer = (acc, grupo) => grupo.hijos.reduce(reducer, [...acc, grupo]);
        return grupos.reduce(reducer, []);
    }

    let trabajador, errores, nombre, error, tipos, gruposAplanados, opcionesDeGrupo, grupos, sedes,
        opcionesDeSede;
    $: trabajador = $store.trabajador;
    $: errores = validaTrabajador(trabajador);
    $: nombre = nombreCompleto(trabajador);

    $: grupos = $storeGrupos.listado;
    $: opcionesDeGrupo = creaOpciones(grupos);
    $: gruposAplanados = aplanarGrupos(grupos);

    $: sedes = $storeSedes.listado;
    $: opcionesDeSede = sedes.reduce((acc, sede) => ([...acc, {
        valor: sede.id,
        etiqueta: sede.nombre
    }]), []);

    const dispatch = createEventDispatcher();

    const actualizaCampo = campo => ({target, detail}) => store.actualizaCampo(campo, target ? target.value : detail);

    const enviaFormulario = () => store.guarda().then(_ => dispatch('enviado'));

    const actualizaGrupo = ({target}) => {
        store.actualizaCampo('grupo', gruposAplanados.filter(x => x.id === +target.value)[0]);
    }

    const actualizaSede = ({target}) => store.actualizaCampo('sede', sedes.filter(x => x.id === +target.value)[0])
</script>

<style>
    @media (min-width: 768px) {
        .fila {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: var(--padding-global);
        }

        .fila-3 {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-gap: var(--padding-global);
        }
    }
</style>

<Caja>
    <div slot="titulo">
        <Subtitulo>{titulo}</Subtitulo>
    </div>

    <form on:submit={enviaFormulario}>
        <div class="fila-3">
            <CampoDeTexto id="nombre" label="Nombre" value={trabajador.nombre} icono="face"
                          valido={!errores.nombre} mensajeDeError={errores.nombre}
                          on:input={actualizaCampo('nombre')}/>

            <CampoDeTexto id="apellidos" label="Apellidos" value={trabajador.apellidos}
                          valido={!errores.apellidos} mensajeDeError={errores.apellidos}
                          icono="face" on:input={actualizaCampo('apellidos')}/>
            <CampoDeTexto id="nif" label="NIF" value={trabajador.nif} icono="account_box"
                          valido={!errores.nif} mensajeDeError={errores.nif}
                          on:input={actualizaCampo('nif')}/>
        </div>

        <div class="fila-3">
            <CampoDeTexto id="telefono" label="Teléfono" value={trabajador.telefono}
                          icono="phone"
                          valido={!errores.telefono} mensajeDeError={errores.telefono}
                          on:input={actualizaCampo('telefono')}/>

            <CampoDeTexto id="email" label="E-mail" value={trabajador.email || ''}
                          icono="email" required="true"
                          valido={!errores.email} mensajeDeError={errores.email}
                          on:input={actualizaCampo('email')}/>

            <CampoDeTexto id="codigo" label="Código" value={trabajador.codigo}
                          icono="keyboard" required="true"
                          valido={!errores.codigo} mensajeDeError={errores.codigo}
                          on:input={actualizaCampo('codigo')}/>
        </div>

        <div class="fila-3">
            <CampoDeSeleccion id="padre" label="Grupo"
                              value={trabajador.grupo ? trabajador.grupo.id : null}
                              icono="account_tree" valido={true}
                              opciones={opcionesDeGrupo}
                              on:input={actualizaGrupo}/>

            <CampoDeSeleccion id="sede" label="Sede"
                              value={trabajador.sede ? trabajador.sede.id : null}
                              icono="business" valido={true}
                              opciones={opcionesDeSede}
                              on:input={actualizaSede}/>

            <CampoDeTexto id="tarjeta" label="Tarjeta" value={trabajador.tarjeta || ''}
                          icono="credit_card"
                          valido={!errores.tarjeta} mensajeDeError={errores.tarjeta}
                          on:input={actualizaCampo('tarjeta')}/>
        </div>

        <div class="fila-3">
            <CampoDeTexto id="identificador" label="Identificador externo"
                          value={trabajador.identificador || ''}
                          icono="badge"
                          valido={!errores.identificador} mensajeDeError={errores.identificador}
                          on:input={actualizaCampo('identificador')}/>

            <CampoDeFecha id="fecha" label="Fecha de antigüedad" icono="calendar_today"
                          value={trabajador.antiguedad ? new Date(trabajador.antiguedad) : null}
                          on:change={actualizaCampo('antiguedad')}/>

            <CampoDeImagen id="imagen" label="Fotografía" icono="portrait"
                           value={trabajador.foto}
                           on:change={actualizaCampo('foto')}/>
        </div>

        <div class="fila-3">
            <CampoDeCheckbox id="baja" label="Baja" value={trabajador.baja}
                             on:change={actualizaCampo('baja')}/>
        </div>
    </form>

    <div slot="pie">
        <Boton type="submit" disabled={Object.keys(errores).length}
               on:click={enviaFormulario}>Guardar
        </Boton>
    </div>
</Caja>